import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3eb9e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "u-flex-center-center u-mgt-064"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "__text u-upper-case u-bold" }, "more", -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pallet_item = _resolveComponent("pallet-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_TransitionGroup, {
      name: "fade",
      tag: "div",
      mode: "out-in",
      class: "p-color-pallet-grid-container"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.currentShowItems, (color, index) => {
          return (_openBlock(), _createBlock(_component_pallet_item, {
            key: color.id,
            "props-color": color
          }, null, 8 /* PROPS */, ["props-color"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    }),
    (_ctx.data.total > _ctx.data.currentShowItems.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: "__reload u-button-outline u-button-outline--primary u-upper-case u-bold",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.load()))
          }, _hoisted_3)
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}